<template>
    <div class="ReportsPane">
        <div class="container-fluid container-fill">
            <div class="row">
                <div class="col-md-4">
                    <h4>Appointment Reports:</h4>
                    <ReportDownloader report-label="Appointments List"
                                      endpoint="MentalHealth/Appointments/Reports/AppointmentsList"
                                      :parameter-schema="ParamsEmployeeStartEnd"
                                      report-description="Generates a list of Psychiatric Appointments in a specific time range, with an optional filter for provider" />

                </div>
                <div class="col-md-4">
                    
                </div>
                <div class="col-md-4">
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import components
    import ReportDownloader from '../../Core/UI/ReportDownloader.vue';

    export default {
        props: [],
        data: function () {
            return {
                ParamsEmployeeStartEnd: [
                    {
                        Label: "Provider:",
                        Name: "EmployeeID",
                        Type: "Select",
                        Options: [
                            {
                                text: "ALL",
                                value: null
                            },
                            {
                                text: "Dr. Garcia",
                                value: "34eb04af-7980-4014-81bb-08dc711b7ad88"
                            },
                            {
                                text: "Dr. Mand",
                                value: "2654b90a-ed3f-41e4-e1b8-08dbbb82c673"
                            },
                            {
                                text: "Dr. Patel",
                                value: "30a0f2f0-6d50-44a3-3598-08d95cdc4393"
                            },
                            {
                                text: "Dr. Ramsinghani",
                                value: "309021d5-c963-41e4-4548-08db088014df"
                            },
                            {
                                text: "Dr. Siragusa",
                                value: "af466de9-b7f6-4a0f-7a30-08dcd992a0fb"
                            },
                            {
                                text: "Dr. Cooper (Inactive)",
                                value: "9820b9c3-bc79-4b40-359a-08d95cdc4393"
                            },
                            {
                                text: "Dr. Tom (Inactive)",
                                value: "506b228c-a44c-4b44-066e-08da70bcad63"
                            },
                            {
                                text: "Dr. Shin (Inactive)",
                                value: "c87c6161-8fe4-4f80-066f-08da70bcad63"
                            },
                            {
                                text: "Dr. Clarey (Inactive)",
                                value: "6fea255d-21c3-4bca-1a10-08db686a098e"
                            },
                            {
                                text: "Dr. Lee (Inactive)",
                                value: "cef74e5b-5ece-495d-1a11-08db686a098e"
                            },
                            {
                                text: "Dr. Feinstein (Inactive)",
                                value: "1034e92c-f3a7-4275-a2fa-08db8df9df73"
                            }
                        ]
                    },
                    {
                        Label: "Start Date:",
                        Name: "StartDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "End Date:",
                        Name: "EndDate",
                        Type: "Date",
                        Required: true
                    }
                ],
            };
        },
        methods: {
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
        },
        computed: {

        },
        components: {
            ReportDownloader
        },
        mounted() {

        }
    }
</script>